import { render, staticRenderFns } from "./ChangeAnswerEffect.vue?vue&type=template&id=fcbf2430&scoped=true&"
import script from "./ChangeAnswerEffect.vue?vue&type=script&lang=js&"
export * from "./ChangeAnswerEffect.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fcbf2430",
  null
  
)

export default component.exports